export const API_PATH = '/api';

export const DOMAINS = {
  MAIN: 'luckyelfcasino.com',
  DEV: 'dev.luckyelfcasino.com',
  DEV_2: 'dev.luckyelfcasino2.com',
  LOCAL: 'localhost',
  MIRROR_1: 'luckyelfcasino1.com',
  MIRROR_2: 'luckyelfcasino2.com',
  MIRROR_3: 'luckyelfcasino3.com',
  MIRROR_10: 'luckyelfcasino10.com',
};

export const API_URLS = {
  MAIN: 'https://www.luckyelfcasino.com',
  MIRROR_1: 'https://www.luckyelfcasino1.com',
  MIRROR_2: 'https://www.luckyelfcasino2.com',
  MIRROR_3: 'https://www.luckyelfcasino3.com',
  MIRROR_10: 'https://www.luckyelfcasino10.com',
};

export const hostToApiMap = {
  [DOMAINS.MIRROR_1]: API_URLS.MIRROR_1,
  [DOMAINS.MIRROR_2]: API_URLS.MIRROR_2,
  [DOMAINS.DEV_2]: API_URLS.MIRROR_2,
  [DOMAINS.MIRROR_3]: API_URLS.MIRROR_3,
  [DOMAINS.MIRROR_10]: API_URLS.MIRROR_10,
  [DOMAINS.MAIN]: API_URLS.MAIN,
  [DOMAINS.DEV]: API_URLS.MAIN,
  [DOMAINS.LOCAL]: '',
};

export const ONE_SIGNAL_IDS = {
  MAIN: '9e9fa2b3-a39b-43fd-8e0a-7add19770d5f',
  MIRROR_2: 'da848702-438a-4899-953c-f78fe4fd4eeb',
  MIRROR_3: '76d62c9b-25a8-4141-b592-68dcd752d00e',
  MIRROR_10: '3880a3b1-3106-416b-8548-932476c71481',
};

export const PAYMENTS_REDIRECT_ROUTES = {
  SUCCESS: '/deposit/success',
  FAILURE: '/deposit/failure',
  PENDING: '/deposit/pending',
  SUPPORT: '/support',
};

export const AUTH_RATE_LIMIT_LOGIN_ATTEMPTS = 10;

export const AUTH_RATE_LIMIT_LOGIN_ATTEMPTS_TTL = 10_800_000;

export const TOURNAMENT_SS_WIDGET_LINK =
  'https://iframe.a8r.games/widgets/latest/index.js';

export const TOURNAMENT_LEADERBOARD_WIDGET_URL = 'https://api.lobby.a8r.games';

export const X_SELL_USER_API = 'https://v1.xsell-lup.xyz/api/users';

export const GAMIFICATION_API =
  'https://gsb.lv02-prod.k8s.gamification-lup.xyz';

export const TEMPORARY_ENV =
  'temporary-env.s3-website.eu-central-1.amazonaws.com';

export const SANDBOX_HOST = 'luckyelf-sandbox.com';
export const API_PROXY_URL = 'https://dev-bff.luckyelfcasino.com/proxy/le';
export const API_SANDBOX_URL = 'https://www.luckyelf-sandbox.com';

export const DEMO_CURRENCY = 'FUN';

export const NDB_STAGS = [
  '105424',
  '121744',
  '93406',
  '111097',
  '95853',
  '93525',
  '205823',
  '103172',
  '91714',
  '212432',
  '93377',
  '93161',
  '151644',
  '129674',
  '91311',
  '90949',
];
